import { Navigate, Route, Routes } from "react-router-dom";
import AdminDashboard from "../Components/AdminComponent/AdminDashboard/AdminDashboard";
import { useUserContext } from "../Context/UserContext";
import AdminPage from "../Components/CommonComponent/AdminPage/AdminPage";
import Profile from "../Components/CommonComponent/Profile/Profile";
import RestaurantPage from "../Components/CommonComponent/RestaurantPage/RestaurantPage";
import RegisterAdmin from "../Components/CommonComponent/AdminPage/RegisterAdmin/RegisterAdmin";
import Bookings from "../Components/CommonComponent/Bookings/Bookings";
import ViewBooking from "../Components/CommonComponent/Bookings/ViewBooking";
import Diners from "../Components/CommonComponent/Diners/Diners";
import Coupons from "../Components/CommonComponent/Coupons/Coupons";
import Report from "../Components/CommonComponent/Report/Report";
import NotFound from "../Components/CommonComponent/NotFound/NotFound";
import Settlement from "../Components/CommonComponent/Report/Settlement/Settlement";
import ReviewList from "../Components/CommonComponent/ReviewList/ReviewList";

const PrivateRoutes = () => {
  const { userRole } = useUserContext();
  return (

    <>
      <Routes>
        {/* SUPERADMIN ROUTES */}
        <Route
          path="/"
          element={!['diner', 'restaurant'].includes(userRole()) ? <AdminDashboard /> : <NotFound />}
        />


        {/* COMMON ROUTES FOR ALL ADMIN */}
        <Route
          path="/profile"
          element={userRole() ? <Profile /> : <Navigate to='/' />}
        />

        {/* ADMIN ROUTES */}
        <Route path="/restaurants/*" element={!['diner', 'restaurant'].includes(userRole()) ? <RestaurantPage /> : <Navigate to='/' />} />
        <Route path="/reports/*" element={!['diner', 'restaurant'].includes(userRole()) ? <Report /> : <Navigate to='/' />} />
        <Route path="/reports/settlements/*" element={!['diner', 'restaurant'].includes(userRole()) ? <Settlement /> : <Navigate to='/' />} />
        <Route path="/admin" element={!['diner', 'restaurant'].includes(userRole()) ? <AdminPage /> : <Navigate to='/' />} />
        <Route path="/admin/register" element={!['diner', 'restaurant'].includes(userRole()) ? <RegisterAdmin /> : <Navigate to='/' />} />
        <Route path="/bookings" element={!['diner', 'restaurant'].includes(userRole()) ? <Bookings /> : <Navigate to='/' />} />
        <Route path="/bookings/user/:userId" element={!['diner', 'restaurant'].includes(userRole()) ? <Bookings /> : <Navigate to='/' />} />
        <Route path="/bookings/:bookingId" element={<ViewBooking />} />
        <Route path="/bookings/:bookingId" element={<ViewBooking />} />
        <Route path="/diners" element={<Diners />} />
        <Route path="/coupons-offers" element={<Coupons />} />
        <Route path="/reviews" element={<ReviewList />} />
        {/* reviews */}
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default PrivateRoutes;
